export const theme = window.IRIDA?.site.theme || "dark";
export const primaryColour = window.IRIDA?.site.colours.primary || "#1890ff";
